// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"401":"1ebcb422005bd984","2565":"2df16988559565fa","6990":"19dc1478b4d8c93e","7553":"a5edca9a99dac977"}[chunkId] + ".js";
};